import { ChakraStack as Stack } from "@airhelp/react-ui-components";
import type { StackProps } from "@chakra-ui/react";
import { renderDynamicComponent } from "modules/storyblok/DynamicComponent";
import type { SbEditableComponentProps } from "types/storyblok";
import type { AlignerProps } from "./Aligner.d";

export const Aligner = ({
  content,
  sbEditable,
  alignHorizontallyDesktop,
  alignHorizontallyMobile,
  alignHorizontallyTablet,
  alignVerticallyDesktop,
  alignVerticallyMobile,
  alignVerticallyTablet,
  directionDesktop,
  directionMobile,
  directionTablet,
  spacingDesktop,
  spacingMobile,
  spacingTablet,
  textAlignDesktop,
  textAlignMobile,
  textAlignTablet,
}: SbEditableComponentProps<AlignerProps>) => {
  const direction = {
    base: directionMobile,
    md: directionTablet,
    lg: directionDesktop,
  } as StackProps["direction"];

  const spacing = {
    base: spacingMobile,
    md: spacingTablet,
    lg: spacingDesktop,
  } as StackProps["spacing"];

  const alignHorizontally = {
    base: alignHorizontallyMobile,
    md: alignHorizontallyTablet,
    lg: alignHorizontallyDesktop,
  } as StackProps["justify"];

  const alignVertically = {
    base: alignVerticallyMobile,
    md: alignVerticallyTablet,
    lg: alignVerticallyDesktop,
  } as StackProps["align"];

  const textAlign = {
    base: textAlignMobile,
    md: textAlignTablet,
    lg: textAlignDesktop,
  } as StackProps["textAlign"];

  return (
    <Stack
      textAlign={textAlign}
      direction={direction}
      spacing={spacing}
      align={alignHorizontally}
      justify={alignVertically}
      {...sbEditable}
      w="full"
    >
      {renderDynamicComponent(content)}
    </Stack>
  );
};
